import React, { JSX, ReactNode, useMemo } from 'react'
import {
  UNSAFE_LocationContext as LocationContext,
  useLocation,
  useNavigationType,
  useParams
} from 'react-router'
import { OverlayShell } from 'components/OverlayShell'
import { ChatOverlayView } from 'components/ChatOverlayView'
import { useOverlaySocketCredential } from 'hooks/useOverlaySocketCredential'

const FitParamDefault = ({
  value,
  children
}: {
  value: string
  children: ReactNode
}): JSX.Element => {
  const location = useLocation()
  const navigationType = useNavigationType()
  const scoped = useMemo(() => {
    const params = new URLSearchParams(location.search)
    if (params.has('fit')) return { location, navigationType }
    params.set('fit', value)
    return { location: { ...location, search: `?${params.toString()}` }, navigationType }
  }, [location, navigationType, value])
  return <LocationContext.Provider value={scoped}>{children}</LocationContext.Provider>
}

export const ChatOverlayBody = ({
  chatId,
  token,
  defaultFit
}: {
  chatId: string
  token: string
  defaultFit?: number
}): JSX.Element => {
  const view = <ChatOverlayView chatId={chatId} token={token} standalone />
  if (defaultFit === undefined) return view
  return <FitParamDefault value={String(defaultFit)}>{view}</FitParamDefault>
}

export const ChatOverlayPage = (): JSX.Element => {
  const { chatId } = useParams<{ chatId: string }>()
  const token = useOverlaySocketCredential()

  if (chatId == null || chatId === '' || token == null || token === '') {
    return <OverlayShell>{null}</OverlayShell>
  }

  return (
    <OverlayShell>
      <ChatOverlayBody chatId={chatId} token={token} />
    </OverlayShell>
  )
}
